"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-bitwise
const bcp_1 = require("@iov/bcp");
const crypto_1 = require("@iov/crypto");
const encoding_1 = require("@iov/encoding");
const long_1 = __importDefault(require("long"));
const derivation_1 = require("./derivation");
class Serialization {
    static toTimestamp(date) {
        const unixTimestamp = Math.floor(date.getTime() / 1000);
        const epoch = Date.UTC(2016, 4, 24, 17, 0, 0, 0) / 1000;
        const timestamp = unixTimestamp - epoch;
        // Timestamp must be in the signed int32 range (to be stored in a Postgres
        // integer column and to be serializeable as 4 bytes) but has no further
        // plausibility restrictions.
        // https://github.com/LiskHQ/lisk/blob/v1.0.3/logic/transaction.js#L674
        if (timestamp < -2147483648 || timestamp > 2147483647) {
            throw new Error("Timestamp not in int32 range");
        }
        return timestamp;
    }
    static serializeTransaction(unsigned, creationTime, options) {
        if (unsigned.fee) {
            if (unsigned.fee.gasPrice) {
                throw new Error("Found unexpected gasPrice in transaction fee");
            }
            if (unsigned.fee.gasLimit) {
                throw new Error("Found unexpected gasLimit in transaction fee");
            }
            if (!unsigned.fee.tokens) {
                throw new Error("Missing tokens in transaction fee");
            }
        }
        else {
            // Fee is not serialized and determined by the blockchain rules. Thus we allow
            // unset fee for simplicity.
        }
        if (bcp_1.isSendTransaction(unsigned)) {
            if (!unsigned.senderPubkey) {
                throw new Error("Sender pubkey is required");
            }
            if (derivation_1.Derivation.pubkeyToAddress(unsigned.senderPubkey) !== unsigned.sender) {
                throw new Error("Sender pubkey does not match sender address");
            }
            const timestamp = Serialization.toTimestamp(creationTime);
            const timestampBytes = new Uint8Array([
                (timestamp >> 0) & 0xff,
                (timestamp >> 8) & 0xff,
                (timestamp >> 16) & 0xff,
                (timestamp >> 24) & 0xff,
            ]);
            // assert that there are 8 fractionalDigits so this makes sense
            if (unsigned.amount.fractionalDigits !== 8) {
                throw new Error(`Requires 8 fractional digits on Amount, received ${unsigned.amount.fractionalDigits}`);
            }
            const amount = encoding_1.Uint64.fromString(unsigned.amount.quantity);
            const fullRecipientString = unsigned.recipient;
            if (!fullRecipientString.match(/^[0-9]{1,20}[A-Z]{1}$/)) {
                throw new Error("Recipient does not match expected format");
            }
            const recipientNumberString = fullRecipientString.slice(0, -1);
            if (recipientNumberString !== "0" && recipientNumberString[0] === "0") {
                throw new Error("Recipient must not contain leading zeros");
            }
            const recipient = long_1.default.fromString(recipientNumberString, true, 10);
            const memoBytes = unsigned.memo !== undefined ? encoding_1.toUtf8(unsigned.memo) : new Uint8Array([]);
            if (memoBytes.length > options.maxMemoLength) {
                throw new Error(`Memo length exceeds limit. Allowed: ${options.maxMemoLength} bytes`);
            }
            return new Uint8Array([
                0,
                ...timestampBytes,
                ...unsigned.senderPubkey.data,
                ...recipient.toBytesBE(),
                ...amount.toBytesLittleEndian(),
                ...memoBytes,
            ]);
        }
        else {
            throw new Error("Unsupported kind of transaction");
        }
    }
    static transactionId(unsigned, creationTime, primarySignature, options) {
        const serialized = Serialization.serializeTransaction(unsigned, creationTime, options);
        const hash = new crypto_1.Sha256(serialized).update(primarySignature.signature).digest();
        const idString = long_1.default.fromBytesLE(Array.from(hash.slice(0, 8)), true).toString(10);
        return idString;
    }
}
exports.Serialization = Serialization;
//# sourceMappingURL=serialization.js.map